<script lang="ts">
  import type { CommentAttachment } from "../../comments/CommentTypes";
  import cn from "classnames";
  import css from '../../../../css/comments.pcss.json'
  import GameStatusButton from "../../GameStatusButton_svelte.svelte";

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false
</script>

<a href={attachment.gameInfo.url ?? attachment.url} class={cn({
    [css['comment__attachment__game']]: true,
    [css['comment__attachment--only']]: onlyAttachment
  })}>
  <picture>
    <img alt="" src={attachment.gameInfo.poster} loading="lazy"/>
  </picture>
  <span class={css['comment__attachment__game__title']}>{attachment.gameInfo.name}</span>
  <span class={css['comment__attachment__game__date']}>{attachment.gameInfo.releaseDate}</span>
  <GameStatusButton gameId={attachment.gameId} status={attachment.gameInfo.status}/>
  <slot name="delete"></slot>
</a>
